import Panel from "../components/common/Panel";
import Seo from "../components/common/Seo";
import { t } from "../i18n/messages";
import { useAppState } from "../state/AppStateProvider";
import { buildPath } from "../utils/routing";

const DELIVERY_STAGES = [
  { key: "settlementStage1" },
  { key: "settlementStage2" },
  { key: "settlementStage3" },
  { key: "settlementStage4" },
  { key: "settlementStage5" },
];

export default function SettlementPage({ locale }) {
  const { pendingOrders } = useAppState();

  return (
    <>
      <Seo
        locale={locale}
        title={`Chronos Arte Node | ${t(locale, "navSettlement")}`}
        description={t(locale, "settlementDesc")}
        path={buildPath(locale, "settlement")}
      />

      <Panel title={t(locale, "navSettlement")} description={t(locale, "settlementPanelDesc")}>
        <div className="steps-grid compact">
          {DELIVERY_STAGES.map((stage, idx) => (
            <article key={stage.key} className="step-card">
              <div className="step-number">{String(idx + 1).padStart(2, "0")}</div>
              <h4>{t(locale, stage.key)}</h4>
            </article>
          ))}
        </div>
      </Panel>

      <Panel title={t(locale, "settlementOrdersTitle")} description={t(locale, "settlementOrdersDesc")}>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{t(locale, "settlementColId")}</th>
                <th>{t(locale, "settlementColAsset")}</th>
                <th>{t(locale, "settlementColStatus")}</th>
                <th>{t(locale, "settlementColNextStep")}</th>
              </tr>
            </thead>
            <tbody>
              {pendingOrders.length ? (
                pendingOrders.map((row) => (
                  <tr key={row.id}>
                    <td>{row.id}</td>
                    <td>{row.asset}</td>
                    <td>{row.status}</td>
                    <td>{row.nextStep}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>{t(locale, "settlementNoOrders")}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Panel>
    </>
  );
}
